// extracted by mini-css-extract-plugin
export var column = "styles-module--column--5222b";
export var container = "styles-module--container--fee66";
export var icon = "styles-module--icon--e7543";
export var temperature = "styles-module--temperature--f29d5";